import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IUserProviderUnit extends IModelBase {
  UserId: string
  UnitId: number
}

@Injectable()
export class UserProviderUnitODataService extends ODataService<IUserProviderUnit> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'UserProviderUnits'
  }
}
